import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to top whenever the route changes.
 * Gives a "refresh" feel when navigating between pages.
 */
const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prevent browser from restoring scroll position after navigation
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    scrollToTop();
    // Run again after paint in case layout shifts (e.g. new page content)
    const id = requestAnimationFrame(() => {
      scrollToTop();
    });
    // Fallback: scroll again after a short delay for async content / layout
    const t = setTimeout(scrollToTop, 100);
    return () => {
      cancelAnimationFrame(id);
      clearTimeout(t);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
